<template>
  <div class="answer">
    <textarea
      v-model="text"
      ref="textArea"
      auto-grow
      rows="2"
      class="textarea"
      :placeholder="placeholder"
      :style="leaveRoomForCode ? `padding-right: ${leaveRoomForCode}` : ''"
    />
    <div class="buttons">
      <v-btn text small dense class="ml-3 cancel" @click="cancel">
        {{ $t('actions.cancel') }}
      </v-btn>
      <v-btn text small dense class="save" @click="save">
        {{ $t('actions.save') }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TextInput',
  props: {
    elementId: {
      type: String,
      default: undefined,
    },
    leaveRoomForCode: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    save() {
      this.$emit('save', { text: this.text, elementId: this.elementId });
    },
    cancel() {
      this.$emit('cancel', { elementId: this.elementId });
    },
  },
};
</script>
<style scoped>
.answer {
  background-color: #f6f7ff;
  border: 1px solid #4456f5;
  padding: 10px;
  border-radius: 5px;
}

.answer:focus-within {
  outline: 1px solid #4456f5;
}

.textarea {
  width: 100%;
  border: none;
  outline: none;
  padding: 4px;
  resize: none;
  font-size: 12px;
}

.textarea::focus {
  outline: none;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.save {
  background-color: rgba(68, 86, 245, 0.1);
  font-weight: 600;
  color: #4456f5;
  border: none;
  padding: 10px;
  /* border-radius: 5px; */
  transition: all 0.2s ease-in-out;
  text-transform: none;
  font-size: 10px;
}

.save:hover {
  background-color: #4456f5;
  color: #fff;
}

.cancel {
  color: rgba(0, 0, 0, 0.3);
  margin-right: 15px;
  padding: 10px;
  /* border-radius: 5px; */
  transition: all 0.2s ease-in-out;
  text-transform: none;
  font-size: 10px;
}

.cancel:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
